import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Band from './Band';
import './Bands.css';
// import useModal from '../../../hooks/useModal';
// import Modal from './Modal/Modal';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Friends from '../../../ethereum/Friends';
import web3 from '../../../ethereum/web3';
import BandAbi from '../../../ethereum/build/Band.json';

import { FaRegClone } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const BodyContainer = styled.div`
    display: grid;
    /* align-items: center; */
    /* justify-content: center
  ; */
    margin: 50px 0px;
`;

const Container = styled.div`
    /* grid-template-columns: repeat(auto-fill, 100px); */
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 60px;
`;

const ScrollBar = styled.div`
    overflow-y: auto;

    ::-webkit-scrollbar {
        width: 0.5em;
    }

    ::-webkit-scrollbar-track {
        /* box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
        box-shadow: inset 6px 6px 12px #e4e4e7, inset -6px -6px 12px #fcfcff;
    }

    ::-webkit-scrollbar-thumb {
        background-color: lightgrey;
        /* outline: 1px solid slategrey; */
        border-radius: 20px;
    }
`;

const Bands = styled(ScrollBar)`
    margin: 20px 0px;
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    height: 600px;
    width: 250px;
    box-shadow: 14px 14px 28px #cccccf, -14px -14px 28px #ffffff;
    border-radius: 15px;
    align-items: center;
    justify-content: center;
`;

const Sent = styled(ScrollBar)`
    height: 600px;
    width: 400px;
    box-shadow: 14px 14px 28px #cccccf, -14px -14px 28px #ffffff;
    border-radius: 15px;
    display: grid;
    justify-items: center;
`;

const Received = styled(Sent)``;

const FriendList = styled.div`
    height: 530px;
    width: 380px;
    display: grid;
    justify-items: center;
    gap: 40px;
    /* margin: 10px 0px; */
`;

const Friend = styled.div`
    height: fit-content;
    width: 350px;
    /* box-shadow: 14px 14px 28px #cccccf, -14px -14px 28px #ffffff; */
    border-radius: 10px;
    display: grid;
    align-items: center;
    justify-items: center;
    grid-gap: 10px;
    /* position: relative; */
`;

const FriendAddress = styled.div`
    font-weight: bolder;
    /* top: 10px; */
    /* left: 10px; */
    /* position: absolute; */
    /* padding: 10px 15px; */

    &:hover {
        cursor: pointer;
    }
`;

const FriendMessage = styled.div`
    /* top: 10px; */
    /* right: 10px; */
    /* margin: 50px 0px 20px 0px; */
    /* position: absolute; */
    padding: 10px 15px;
    border-radius: 10px;
    box-shadow: 6px 6px 12px #e4e4e7, -6px -6px 12px #fcfcff;
    height: fit-content;
    width: 300px;
    /* display: flex; */
    /* flex-wrap: wrap; */
    word-wrap: break-word;
    text-align: center;
`;

const StyledLink = styled(Link)`
    text-decoration: none;
    color: black;
`;

const Friendships = ({ id }) => {
    const [listFriendships, setListFriendships] = useState(null);
    const [clickedBand, setClickedBand] = useState('');
    const [listFriends, setListFriends] = useState(null);
    const [listBuddies, setListBuddies] = useState(null);
    const [sentLoading, setSentLoading] = useState(false);
    const [receivedLoading, setReceivedLoading] = useState(false);

    const displayFriendships = async () => {
        try {
            const bandsAddress = await Friends.methods.getBands().call();

            let promises = bandsAddress.map((band) => {
                const bandIns = async () => {
                    let BandInstance = await new web3.eth.Contract(
                        BandAbi,
                        band
                    );
                    return BandInstance;
                };
                return bandIns().then((BandInstance) => {
                    return BandInstance.methods
                        .getFriends(id)
                        .call()
                        .then((friends) => {
                            return BandInstance.methods
                                .getBuddies(id)
                                .call()
                                .then((buddies) => {
                                    return friends.length || buddies.length
                                        ? BandInstance.methods
                                              .getBandDetails()
                                              .call()
                                              .then((details) => {
                                                  // console.log(details);
                                                  let { retName, retUri } =
                                                      details;
                                                  return (
                                                      <div key={band}>
                                                          <Band
                                                              address={band}
                                                              uri={retUri}
                                                              setClickedBand={
                                                                  setClickedBand
                                                              }
                                                          />
                                                      </div>
                                                  );
                                              })
                                        : null;
                                });
                        });
                });
            });

            Promise.all(promises).then((listFriendships) => {
                listFriendships.reverse();
                setListFriendships(listFriendships);
            });
        } catch (err) {
            // console.log(err, "Problem while displaying friendships");
            console.error(err);
            window.location.reload();
        }
    };

    useEffect(() => {
        displayFriendships();
        return () => {
            setListFriendships(null);
        };
    }, []);

    const displayBuddies = async () => {
        setSentLoading(true);
        if (clickedBand !== '') {
            try {
                let BandInstance = await new web3.eth.Contract(
                    BandAbi,
                    clickedBand
                );

                let buddies = await BandInstance.methods.getBuddies(id).call();

                let promises = buddies.map((buddy) => {
                    let bAddress =
                        buddy.slice(0, 6) + '.....' + buddy.slice(-7);

                    return web3.eth.getBlock('latest').then(async (block) => {
                        let latestBlock = block.number;
                        console.log('latest block: ', latestBlock);
                        let listBuddies = [];
                        for (
                            let FromBlock = 17545954;
                            // ToBlock = FromBlock + 1000;
                            FromBlock + 1000 <= latestBlock;
                            FromBlock = FromBlock + 1000
                        ) {
                            // return BandInstance.getPastEvents('Message', {
                            //     filter: { _receiver: buddy, _sender: id },
                            //     fromBlock: FromBlock, // 17545954,
                            //     toBlock: FromBlock + 1000, // 'latest',
                            // }).then((message) => {
                            //     // console.log("Sent message: ", message);
                            //     console.log('message: ', message);
                            //     return message.length > 0 ? (
                            // <Friend key={buddy}>
                            //     <FriendAddress>
                            //         <StyledLink to={`${buddy}`}>
                            //             {bAddress}{' '}
                            //         </StyledLink>
                            //         <CopyToClipboard text={buddy}>
                            //             <FaRegClone />
                            //         </CopyToClipboard>
                            //     </FriendAddress>
                            //     <FriendMessage>
                            //         {message[0].returnValues._message}
                            //     </FriendMessage>
                            // </Friend>
                            //     ) : null;
                            // });
                            // let message = [];

                            let message = await BandInstance.getPastEvents(
                                'Message',
                                {
                                    filter: {
                                        _receiver: buddy,
                                        _sender: id,
                                    },
                                    fromBlock: FromBlock, // 17545954,
                                    toBlock: FromBlock + 1000, // 'latest',
                                }
                            );
                            // console.log('sentMessage: ', message);

                            if (message.length > 0) {
                                listBuddies.push(
                                    <Friend key={buddy}>
                                        <FriendAddress>
                                            <StyledLink to={`${buddy}`}>
                                                {bAddress}{' '}
                                            </StyledLink>
                                            <CopyToClipboard text={buddy}>
                                                <FaRegClone />
                                            </CopyToClipboard>
                                        </FriendAddress>
                                        <FriendMessage>
                                            {message[0].returnValues._message}
                                        </FriendMessage>
                                    </Friend>
                                );
                            }
                        }
                        setListBuddies(listBuddies);
                        setSentLoading(false);
                        // console.log('sentLoading: ', sentLoading);
                    });
                });

                // Promise.all(promises).then((listBuddies) => {
                //     // listFriends.reverse();
                //     setListBuddies(listBuddies);
                // });
            } catch (err) {
                // console.log(err, "Problem while displaying friends");
                // window.location.reload();
                console.error(err);
            }
        }
    };

    const displayFriends = async () => {
        setReceivedLoading(true);
        if (clickedBand !== '') {
            try {
                let BandInstance = await new web3.eth.Contract(
                    BandAbi,
                    clickedBand
                );

                let friends = await BandInstance.methods.getFriends(id).call();

                let promises = friends.map((friend) => {
                    let fAddress =
                        friend.slice(0, 6) + '.....' + friend.slice(-7);
                    // return BandInstance.getPastEvents('Message', {
                    //     filter: { _receiver: id, _sender: friend },
                    //     fromBlock: 17083999,
                    //     toBlock: 'latest',
                    // }).then((message) => {
                    //     // console.log("Recived message: ", message);
                    //     return (
                    //         <Friend key={friend}>
                    //             <FriendAddress>
                    //                 <StyledLink to={`${friend}`}>
                    //                     {fAddress}{' '}
                    //                 </StyledLink>
                    //                 <CopyToClipboard text={friend}>
                    //                     <FaRegClone />
                    //                 </CopyToClipboard>
                    //             </FriendAddress>
                    //             <FriendMessage>
                    //                 {message[0].returnValues._message}
                    //             </FriendMessage>
                    //         </Friend>
                    //     );
                    // });

                    return web3.eth.getBlock('latest').then(async (block) => {
                        let latestBlock = block.number;
                        // console.log('latest block: ', latestBlock);
                        let listFriends = [];
                        for (
                            let FromBlock = 17545954;
                            // ToBlock = FromBlock + 1000;
                            FromBlock + 1000 <= latestBlock;
                            FromBlock = FromBlock + 1000
                        ) {
                            let message = await BandInstance.getPastEvents(
                                'Message',
                                {
                                    filter: {
                                        _receiver: id,
                                        _sender: friend,
                                    },
                                    fromBlock: FromBlock, // 17545954,
                                    toBlock: FromBlock + 1000, // 'latest',
                                }
                            );
                            // console.log('rceivedMessage: ', message);

                            if (message.length > 0) {
                                listFriends.push(
                                    <Friend key={friend}>
                                        <FriendAddress>
                                            <StyledLink to={`${friend}`}>
                                                {fAddress}{' '}
                                            </StyledLink>
                                            <CopyToClipboard text={friend}>
                                                <FaRegClone />
                                            </CopyToClipboard>
                                        </FriendAddress>
                                        <FriendMessage>
                                            {/* {message.length > 0 ? (
                                                <span>
                                                    {
                                                        message[0].returnValues
                                                            ._message
                                                    }
                                                    :{' '}
                                                </span>
                                            ) : (
                                                <span>
                                                    Please wait, it's loading...
                                                </span>
                                            )} */}
                                            {message[0].returnValues._message}
                                        </FriendMessage>
                                    </Friend>
                                );
                            }
                            // console.log('receivedLoading: ', receivedLoading);
                        }

                        // if (listFriends) setReceivedLoading(false);

                        setListFriends(listFriends);

                        setReceivedLoading(false);
                        // console.log('receivedLoading: ', receivedLoading);
                    });
                });

                // Promise.all(promises).then((listFriends) => {
                //     // listFriends.reverse();
                //     setListFriends(listFriends);
                // });
            } catch (err) {
                // console.log(err, "Problem while displaying friends");
                // window.location.reload();
                console.error(err);
            }
        }
    };

    useEffect(() => {
        displayBuddies();

        // return () => {
        //     setListBuddies(null);
        //     setSentLoading(false);
        // };
    }, [clickedBand]);

    useEffect(() => {
        displayFriends();
        // return () => {
        //     setListFriends(null);
        //     setSentLoading(false);
        // };
    }, [clickedBand]);

    // useEffect(() => {
    //     displayBuddies();
    //     displayFriends();
    //     return () => {
    //         setListFriends(null);
    //         setListBuddies(null);
    //         setReceivedLoading(false);
    //         setSentLoading(false);
    //         // setClickedBand('');
    //     };
    //     // console.log("band: ", clickedBand);
    // }, [clickedBand]);

    return (
        <BodyContainer>
            <span className="gradient-underline">Friendships</span>
            <Container>
                <Bands>
                    {/* <Band toggle={toggle} isShowing={isShowing} /> */}
                    {/* <Modal isShowing={isShowing} hide={toggle} /> */}
                    {listFriendships}
                </Bands>
                <Sent>
                    <h2>Sent</h2>
                    <FriendList>
                        {listBuddies ? (
                            listBuddies
                        ) : (
                            <span>
                                {clickedBand === ''
                                    ? 'Please select a Band '
                                    : sentLoading
                                    ? "Please wait, it's loading..."
                                    : 'No buddies yet'}
                            </span>
                        )}
                    </FriendList>
                </Sent>
                <Received>
                    <h2>Received</h2>
                    <FriendList>
                        {listFriends ? (
                            listFriends
                        ) : (
                            <span>
                                {clickedBand === '' ? (
                                    'Please select a Band '
                                ) : receivedLoading ? (
                                    <span>"Please wait, it's loading..."</span>
                                ) : (
                                    'No friends yet'
                                )}
                            </span>
                        )}
                    </FriendList>
                </Received>
            </Container>
        </BodyContainer>
    );
};

export default Friendships;
